import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable, tap } from 'rxjs';

import { STRIPE_BILLING_PATH } from '@ninety/platform/models';
import { BillingService } from '@ninety/platform/services/services/billing.service';
import { extractValueFromStore } from '@ninety/platform/services/state-util';
import { SpinnerService } from '@ninety/platform/state';
import { selectCurrentUserIsAdminOrOwner } from '@ninety/platform/state/app-entities/users/users-state.selectors';
import { selectAuthShouldHaveAccess } from '@ninety/platform/state/app-global/auth/auth.selectors';

@Injectable({ providedIn: 'root' })
export class ActiveSubscriptionGuard {
  constructor(
    private readonly store: Store,
    public readonly spinnerService: SpinnerService,
    private readonly router: Router
  ) {}

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.store.select(selectAuthShouldHaveAccess).pipe(
      map(authShouldHaveAccess => BillingService.isAllowedLocationForUnpaid() || authShouldHaveAccess),
      tap(shouldHaveAccess => {
        if (!shouldHaveAccess) this.navigateToBilling();
      })
    );
  }

  private navigateToBilling() {
    const isAdminOrOwner = extractValueFromStore(this.store, selectCurrentUserIsAdminOrOwner);

    if (isAdminOrOwner) {
      this.router.navigateByUrl(`/settings/${STRIPE_BILLING_PATH}`);
    } else {
      this.router.navigateByUrl('/home');
    }
  }
}
